import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import baseDialogPropTypes from './baseDialogPropTypes';
const InfoDialog = props => {
    const { content, onClose, className } = props;
    const dialogClassName = `${className ? className : ''} info-dialog`;
    return _jsx(Dialog, Object.assign({}, props, { body: content, onHide: onClose, className: dialogClassName }));
};
InfoDialog.propTypes = Object.assign(Object.assign({}, baseDialogPropTypes), { content: PropTypes.node });
export default InfoDialog;
